<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <AdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>Taxation file creation</h4>

              <br />
              <p>
                This tool will allow you to merge a Orders Report and a HR Staffing file to obtain a Taxation file
              </p>
              <br />
              <p>
                <strong>Important:</strong> none of the files mentioned will be uploaded to the server. The merge will happen in your computer. This
                only means that none of the information contained in your HR Staffing will at any point leave your computer.
              </p>
              <hr />

              <b-form @submit.prevent="generateTaxFiles">
                <div class="row border rounded">
                  <div class="col p-2">
                    <p style="color: black;"><strong> Orders Report</strong></p>
                    <p>
                      This is the file you can download from Incentiveweb in the
                      <router-link :to="{ name: 'GenerateExcelReport' }">Generate Excel Report</router-link>
                      section.
                    </p>
                    <fieldset class="border rounded upload">
                      <input class="p-3" type="file" id="ordersReport" @change="handleOrderReportFileSelect" />
                    </fieldset>
                  </div>
                  <div class="col p-2">
                    <p style="color: black;"><strong> HR Staffing</strong></p>
                    <p>
                      This file must come from your organization and contain a sheet called Active with at least the columns:
                    </p>
                    <p>- EMPLOYEE_NUMBER</p>
                    <p>- EMPLOYEE_FIRST_NAME</p>
                    <p>- EMPLOYEE_LAST_NAME</p>
                    <p>- EMPLOYEE_EMAIL_ADDRESS</p>
                    <fieldset class="border rounded upload">
                      <input class="p-3" type="file" id="hrStaffing" @change="handleHRStaffingFileSelect" />
                    </fieldset>
                  </div>
                </div>
                <button class="btn btn-primary mt-2 mb-3">
                  Download
                </button>
              </b-form>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';
import { handleOrderReportFileSelect, handleHRStaffingFileSelect, generateTaxFiles } from './liberty-taxation_report';

export default {
  name: 'GenerateExcelReport',
  data() {
    return {};
  },
  components: {
    AdminSidebar,
    Header,
    Footer,
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'reportsGenerateTaxationReport',
        activeMenu: this.activeMenu ? this.activeMenu : 'reports',
      });
    },
    handleOrderReportFileSelect() {
      handleOrderReportFileSelect();
    },
    handleHRStaffingFileSelect() {
      handleHRStaffingFileSelect();
    },
    generateTaxFiles() {
      generateTaxFiles();
    },
  },

  created() {
    this.setActiveMenuItem();

    var scriptTag1 = document.createElement('script');
    scriptTag1.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.8/shim.min.js';
    document.getElementsByTagName('head')[0].appendChild(scriptTag1);
    var scriptTag2 = document.createElement('script');
    scriptTag2.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.8/xlsx.full.min.js';
    document.getElementsByTagName('head')[0].appendChild(scriptTag2);
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
fieldset {
  background-image: url('https://qa.incentiveweb.com/images/blue_bg.png');
}
</style>
